"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapError = void 0;
const errors_1 = require("@deliverr/errors");
function mapError(err, validErrorCodes = []) {
    var _a;
    if (!err.response) {
        return new errors_1.DeliverrError({
            code: errors_1.ApiError.UNKNOWN_ERROR,
            payload: err,
        });
    }
    if (validErrorCodes.includes(err.response.data)) {
        return new errors_1.DeliverrError({
            code: err.response.data,
        });
    }
    if (validErrorCodes.includes((_a = err.response.data) === null || _a === void 0 ? void 0 : _a.code)) {
        return new errors_1.DeliverrError({
            code: err.response.data.code,
        });
    }
    const { status, data } = err.response;
    const code = status >= 400 ? errors_1.HttpErrorCodes[status] || errors_1.ApiError.UNKNOWN_ERROR : errors_1.ApiError.UNKNOWN_ERROR;
    return new errors_1.DeliverrError({
        code,
        payload: { status, data },
    });
}
exports.mapError = mapError;
//# sourceMappingURL=ErrorMapper.js.map